import { fromJS, List } from 'immutable';

export function request(state, { sportId }) {
    return state.setIn([ 'collections', sportId, 'state' ], 'IN_PROGRESS');
}

export function error(state, { sportId, errors }) {
    return state.setIn([ 'collections', sportId, 'state' ], 'ERROR')
        .setIn([ 'collections', sportId, 'errors' ], errors);
}

export function finish(state, { sportId, market }) {
    let collectionItems = state.getIn([ 'collections', sportId, 'items' ], List());

    // Get market template Id to save in collection
    const { id: marketId } = market;

    // We should not add any market templates to the state
    // if there is already a market with this ID
    // TODO: When the market id will be generated automatically this can be removed
    if ( !collectionItems.includes(marketId) ) {
        collectionItems = collectionItems.push(marketId);
    }

    return state.setIn([ 'items', marketId ], fromJS(market))
        .setIn([ 'collections', sportId, 'items' ], collectionItems)
        .setIn([ 'collections', sportId, 'state' ], 'FINISHED');
}
